export { TextArea } from './TextArea';
export type { TextAreaProps } from './TextArea';
